import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { Logger } from '../../02_utils/logger';

Swiper.use([Navigation, Pagination]);

export class Slider {
  constructor(private $log: Logger) {
    this.createSlider();
  }

  private createSlider() {
    // const swiper = new Swiper('.c-slider', {
    //   loop: true,
    //   modules: [Navigation, Pagination],
    //   spaceBetween: 24,

    //   pagination: {
    //     el: '.c-slider__pagination',
    //     clickable: true,
    //   },

    //   navigation: {
    //     nextEl: '.c-slider__button--next',
    //     prevEl: '.c-slider__button--prev',
    //   },
    // });

    const swiper = new Swiper('.c-slider__card-element', {
      loop: false,
      modules: [Navigation, Pagination],
      spaceBetween: 12,
      slidesPerView: 'auto',
      grabCursor: true,
      centeredSlides: true,
      pagination: {
        el: '.c-slider__pagination',
        clickable: true,
      },
      on: {
        init: function (swiper) {
          if (!!swiper.navigation) {
            swiper.navigation.destroy();
          }
        }
      },

      navigation: {
        nextEl: '.c-slider__button--next',
        prevEl: '.c-slider__button--prev',
      },
      breakpoints: {
        575.98: {
          spaceBetween: 24
        },
        991.98: {
          spaceBetween: 144
        },
      }
    });
    const swiper2 = new Swiper('.c-slider__normal', {
      loop: false,
      modules: [Navigation, Pagination],
      spaceBetween: 24,
      slidesPerView: 'auto',
      grabCursor: true,
      centeredSlides: true,
      simulateTouch: true,
      touchStartPreventDefault: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function (swiper) {
          if (!!swiper.navigation) {
            swiper.navigation.destroy();
          }
        }
      },
    });

    const swiper3 = new Swiper('.c-slider__job', {
      loop: true,
      modules: [Navigation, Pagination],
      spaceBetween: 24,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      grabCursor: true,
      centeredSlides: false,
      simulateTouch: true,
      touchStartPreventDefault: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function (swiper) {
          if (!!swiper.navigation) {
            swiper.navigation.destroy();
          }
        }
      },
    });

    this.$log.log('Swiper: ', swiper);
    this.$log.log('Swiper: ', swiper2);
    this.$log.log('Swiper: ', swiper3);
  }
}
